import React, { useEffect } from "react";
import { Modal, Button, Row, Col, Spin } from "antd";
import Table from "./Table";
import { RootState } from "../../../../../store";
import { useDispatch, useSelector } from "react-redux";
import LoadingComponent from "../../../../../common/components/icons/LoadingComponent";
import XIconModal from "../../../../../assets/icons/x-icon-modal.svg";
import { HandlerImpl } from "../handler/HandlerImpl";
import CM0027_1Component from "../../../CM0027_1";
import CM0027_2Component from "../../../CM0027_2";
import IconCircleCheck from "../../../../../assets/icons/akar-icons_circle-check-fill.svg";
import { STATUS_CM_CHILD_TABLE } from "../../../../../common/constants/COMMON";
import { resetCM0027 } from "../slice/Slice";
import ApprovalFlow from "../../../../../common/components/approval-flow/ApprovalFlow";
import helpers from "../../../../../common/helpers/common";
import ApproveConfirmModal from "../../../../../common/components/modal-approve-confirm";
import useWindowDimensions from "../../../../../common/helpers/windowDimension";

interface props {
  handler: HandlerImpl;
  afterSuccess?: () => void;
  onSubmit?: () => void;
  onReject?: () => void;
}

function MainUI({ handler, afterSuccess, onSubmit, onReject }: props) {
  const dispatch = useDispatch();

  const isVisibleCM0027 = useSelector(
    (state: RootState) => state.cm0027.isVisibleCM0027
  );
  const documentId = useSelector((state: RootState) => state.cm0027.documentId);
  const documentInfo = useSelector(
    (state: RootState) => state.cm0027.documentInfo
  );
  const isVisibleCM0027_1 = useSelector(
    (state: RootState) => state.cm0027_1.isVisible
  );
  const isVisibleCM0027_2 = useSelector(
    (state: RootState) => state.cm0027_2.isVisible
  );
  const isDisableRetrieveButton = useSelector(
    (state: RootState) => state.cm0027.isDisableRetrieveButton
  );
  useEffect(() => {
    if (isVisibleCM0027 && documentId) {
      Promise.all([
        handler.getReSummarySubmittedProjectOutsourceCostTotal(documentId),
        handler.getProjectAlls(documentId),
        handler.getWorkflowSummaryOutsourceProjectApprovalProcess(documentId),
      ]);
    } else {
      handler.showOffsetColumn(false);
    }
    return () => {
      dispatch(resetCM0027());
    };
  }, [isVisibleCM0027, documentId]);
  const { width } = useWindowDimensions();

  return (
    <Modal
      style={{ marginLeft: width > 1872 ? 300 : 0, marginTop: 40, marginBottom: 40 }}
      className="group-detail-modal modal-fixed-1572"
      visible={isVisibleCM0027}
      centered={width > 1700}
      maskClosable={false}
      width={1572}
      closable={false}
      onCancel={handler.cancelModalCM0027}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {onSubmit && onReject ? (
            <>
              {/* DONE */}
              <ApproveConfirmModal onSubmit={onSubmit} />
              <Button
                className="button-purple cm047-btn-submit"
                icon={<img alt="" src={IconCircleCheck} />}
                size="large"
                onClick={handler.showConfirmApproveModal}
                disabled={
                  !(
                    documentInfo?.status ===
                    STATUS_CM_CHILD_TABLE.MONEY_WAITING_FOR_APPROVAL.CODE
                  ) ||
                  !(
                    handler.currentUserApproval &&
                    helpers.checkApproveInWorkFlow(handler.currentUserApproval)
                  )
                }
                style={{ marginLeft: 16 }}
              >
                承認
              </Button>
              <Button
                size="large"
                className="button-warning cm047-btn-reject"
                onClick={onReject}
                disabled={
                  !(
                    documentInfo?.status ===
                    STATUS_CM_CHILD_TABLE.MONEY_WAITING_FOR_APPROVAL.CODE
                  ) ||
                  !(
                    handler.currentUserApproval &&
                    helpers.checkApproveInWorkFlow(handler.currentUserApproval)
                  )
                }
              >
                否認
              </Button>
            </>
          ) : (
            <Button
              size="large"
              type="primary"
              className="button-purple"
              style={{ marginLeft: 16, width: 120 }}
              disabled={isDisableRetrieveButton}
              onClick={() =>
                documentId
                  ? handler.putReSummaryProjectOutsourceCostRetrieve(
                    { documentId: documentId },
                    afterSuccess
                  )
                  : null
              }
            >
              取り下げ
            </Button>
          )}
          <Button
            size="large"
            style={{ marginLeft: 16, width: 118 }}
            onClick={handler.cancelModalCM0027}
          >
            キャンセル
          </Button>
        </div>
      }
    >
      <Spin indicator={LoadingComponent} spinning={handler.loading}>
        <div
          className="w-100-percent header-modal-containter"
          style={{ height: 50 }}
        >
          <div className="header-modal-title-om004 ">外注費</div>
          <div
            style={{ cursor: "pointer" }}
            onClick={handler.cancelModalCM0027}
          >
            <img alt="" src={XIconModal} style={{ height: 18, width: 18 }} />
          </div>
        </div>
        <div style={{ marginTop: 24, marginBottom: 8 }}>
          <ApprovalFlow
            isNotCheckingUser={true}
            breadcrumb={[]}
            listApprove={handler.workflow}
            currentUserApproval={handler.currentUserApproval}
          />
        </div>
        <div
          style={{ margin: "24px 24px 24px 24px", backgroundColor: "#ffffff" }}
        >
          <Row style={{ marginBottom: 24 }}>
            <Col span={8} style={{ display: "flex" }}>
              <div style={{ marginRight: 24 }} className="CM0017_3-info-title">
                資料名
              </div>
              <div className="CM0017_3-info-content">
                {documentInfo.documentTitle}
              </div>
            </Col>
            <Col span={8} style={{ display: "flex" }}>
              <div style={{ marginRight: 24 }} className="CM0017_3-info-title">
                作成日
              </div>
              <div className="CM0017_3-info-content">
                {documentInfo.createdDate}
              </div>
            </Col>
            <Col span={8} style={{ display: "flex" }}>
              <div style={{ marginRight: 24 }} className="CM0017_3-info-title">
                対象期間
              </div>
              <div className="CM0017_3-info-content">
                {documentInfo.targetPeriod}
              </div>
            </Col>
          </Row>
          <Table
            showOffsetColumn={handler.showOffsetColumn}
            handleScroll={handler.handleScroll}
            openCM0027_1={handler.openCM0027_1}
            openCM0027_2={handler.openCM0027_2}
            summaryTotal={handler.summaryData}
            projects={handler.projects}
            setCompanyExpandKeys={handler.setCompanyExpandKeys}
            checkCompanyKeyExpand={handler.checkCompanyKeyExpand}
            setProjectExpandKeys={handler.setProjectExpandKeys}
            checkProjectKeyExpand={handler.checkProjectKeyExpand}
          />
        </div>
        {isVisibleCM0027_1 ? <CM0027_1Component /> : <></>}
        {isVisibleCM0027_2 ? <CM0027_2Component /> : <></>}
      </Spin>
    </Modal>
  );
}

export default MainUI;
